
import { Config } from 'src/environments/config';

const basePath = Config.baseUrl;
const remitUrl = Config.remitUrl;
// tslint:disable-next-line: one-variable-per-declaration
export const
    BasePath = basePath,
    AuthUrls = {
        login: `${basePath}/backoffice/login`,
        refreshTokens: `${basePath}/backoffice/refresh-token`,
        refreshCustomToken: `${basePath}/backoffice/refresh-custom-token`,
        forgetPassword: `${basePath}/backoffice/forgot/password`,
        resetPassword: `${basePath}/backoffice/confirm/password`,
        changePassword: `${basePath}/backoffice/change/password`,
        verifyOTP: `${basePath}/backoffice/login/verify-otp`,
        resendOTP: `${basePath}/backoffice/login/resend-otp`,
        logout: `${basePath}/backoffice/logout`,
        tokenValidate: `${basePath}/backoffice/validate/token`,
        authenticationRemit: `${remitUrl}/inward/authentication`,
    },
    AdminUserUrls = {
        user: `${basePath}/backoffice/`,
        userList: `user/report`,
        createUser: `create-user`,
        editUser: `user/update`,
        deleteUser: `user/delete`,
        commentslist: `${basePath}/setting/list`,
        userEnable: `${basePath}/backoffice/user/restore`,
        saveSettings: `${basePath}/business-global-settings/transaction-expire/create`,
        getSettings: `${basePath}/business-global-settings/transaction-expire/list`,
    },
    AgentUrls = {
        agent: `${basePath}/backoffice/agent`,
        list: `/list`,
        createAgent: `/create`,
    },
    BranchUrls = {
        branch: `${basePath}/backoffice/branch`,
        list: `/list`,
        createBranch: `/create`,
    },
    rolesUrls = {
        list: `${basePath}/backoffice/roles/list`,
        create: `${basePath}/backoffice/roles/create`,
        update: `${basePath}/backoffice/roles/update/`,
        delete: `${basePath}/backoffice/roles/delete/`
    },
    rolesDetailUrls = {
        list: `${basePath}/backoffice/role-details/list`,
        create: `${basePath}/backoffice/role-details/create`,
        delete: `${basePath}/backoffice/role-details/delete/`,
        roleDetails: `${basePath}/backoffice/role-details`
    },
    MerchantUrls = {
        merchant: `${basePath}/merchant`,
        list: `/list`,
        createMerchant: `/create`,
        uploadImage: `/image/upload`,
        imageUploadAttachment: `/image/upload`,
        downloadImage: `/image/download/`,
        downloadDocument: `${basePath}/backoffice/image/download/`,
        merchantCategory: `${basePath}/merchant/category`,
        listMerchantPayout: `${basePath}/merchant/payout/banks/list`,
        createMerchantPayout: `${basePath}/merchant/payout/banks/create`,
        updateMerchantPayout: `${basePath}/merchant/payout/banks/`,
        deleteMerchantPayout: `${basePath}/merchant/payout/banks/`,
        listPaymentMethod: `${basePath}/merchant/payment/method/list`,
        createMerchantSettlement: `${basePath}/merchant/settlement-configuration/create`,
        editMerchantSettlement: `${basePath}/merchant/settlement-configuration/`,
        getMerchantSettlement: `${basePath}/merchant/settlement-configuration/`,
        runMerchantSettlement: `${basePath}/merchant/settlement/create`,
        bankVerify: `${basePath}/merchant/bank/verify`,
        listMerchantPayment: `${basePath}/merchant/api/configuration/`,
        createMerchantPayment: `${basePath}/merchant/api/configuration`,
        updateMerchantPayment: `${basePath}/merchant/api/configuration/`,
        deleteMerchantPayment: `${basePath}/merchant/api/configuration/`,
        getDebitAmount: `${basePath}/setting/list`,
        getBulkQr: `${basePath}/merchant/qrcode/bulk/generate`,

    },
    CompanyUrls = {
        listMerchantCompany: `${basePath}/merchant/company/list`,
        createMerchantCompany: `${basePath}/merchant/company/create`,
        updateMerchantCompany: `${basePath}/merchant/company/`,
        deleteMerchantCompany: `${basePath}/merchant/company/`,
        linkCompanyWithContact: `${basePath}/merchant/company/contact/create`,
        contactCompanyList: `${basePath}/merchant/company/contacts/list`,
        deleteLinkedCompanyContact: `${basePath}/merchant/company/contact/`,
        ListLinkedCompanyContact: `${basePath}/merchant/company/contact/list`,
        updateMerchantCompanyContact: `${basePath}/merchant/company/contact/`,
        list: `${basePath}/merchant/company/report`,

    },
    ContactUrls = {
        listContact: `${basePath}/merchant/contacts/list`,
        createContact: `${basePath}/merchant/contacts/create`,
        updateContact: `${basePath}/merchant/contacts/`,
        deleteContact: `${basePath}/merchant/contacts/`,
        linkMerchantWithContact: `${basePath}/merchant/owner/create`,
        contactCompanyList: `${basePath}/merchant/company/contacts/list`,
        linkCompanyWithContact: `${basePath}/merchant/company/contact/create`,
        editCompanyWithContact: `${basePath}/merchant/company/contact/`,
        companyContactList: `${basePath}/merchant/contacts/company/list`,
        merchantContactList: `${basePath}/merchant/owner/contact/list`,
        deleteLinkedCompanyContact: `${basePath}/merchant/company/contact/`,
        deleteLinkedMerchantContact: `${basePath}/merchant/owner/`,
        list: `${basePath}/merchant/contacts/report`,

    },

    LocationUrls = {
        location: `${basePath}/backoffice/location`,
        list: `/list`,
        createLocation: `/create`,
        bankVerify: `/bank/verify`,
        staticQrCode: `${basePath}/merchant/generateQR`,
        getPayNowQr: `${basePath}/merchant/location/payNowQR`,
        createLocationProduct: `${basePath}/backoffice/merchant/location/product/create`,
        merchantLocationProductsList: `${basePath}/backoffice/merchant/location/product/list`,
        merchantLocationProductsUpdate: `${basePath}/backoffice/merchant/location/product`,
        deleteMerchantProductLocation: `${basePath}/backoffice/merchant/location/product`,
        saveLocation: `${basePath}/membership-provider/merchant/sync-location/`,
        updateLocation: `${basePath}/membership-provider/location/`,
        removeLocation: `${basePath}/membership-provider/location/`,
        activeLocationslist: `${basePath}/membership-provider/location/list-active-location`,
        inactiveLocationslist: `${basePath}/membership-provider/location/list-inactive-location`,
        createCommission: `${basePath}/membership-provider/commission/create`,
        deleteCommission: `${basePath}/membership-provider/commission/`,
        listCommission: `${basePath}/membership-provider/commission/list`,
        merchantOffersList: `${basePath}/backoffice/merchant/location/product/offer/list`,
        saveOffers: `${basePath}/backoffice/merchant/location/product/offer/create`,
        updateOffers: `${basePath}/backoffice/merchant/location/product/offer/`,
        deleteOffers: `${basePath}/backoffice/merchant/location/product/offer/`,
        productNtLinkedLocation: `${basePath}/backoffice/merchant/product/location/list`,
        merchantLocationForJob: `${basePath}/backoffice/location/list/merchant-location`,

    },
    TerminalUrls = {
        terminal: `${basePath}/backoffice/terminal`,
        list: `/list`,
        createTerminal: `/create`,
    },
    IpAddressUrls = {
        list: `${basePath}/merchant/ip-address/list`,
        create: `${basePath}/merchant/ip-address/create`,
        update: `${basePath}/merchant/ip-address/`,
        delete: `${basePath}/merchant/ip-address/`,

    },
    TransactionUrls = {
        userTransaction: `${basePath}/transaction/report/list`,
        transaction: `${basePath}/transaction/list`,
        inAppTransaction: `${basePath}/backoffice/airtime/inapptransaction/list`,
        remittancetransaction: `${basePath}/transaction/remittance/list`,
        remittancetransactionNew: `${basePath}/transaction/remittance/report/list`,
        listTransactionSummary: `${basePath}/transaction/summary`,
        inAppTransactionStatus: `${basePath}/billpayment/transaction/status`,
        inAppRefund: `${basePath}/billpayment/refund`,
        transactionCount: `${basePath}/transaction/count`,
        transactionMonitoring: `${basePath}/transaction/monitoring/list`,
        userTransactionReport: `${basePath}/report/user/transaction`,
        userReport: `${basePath}/report/user`,
        merchantLocationReport: `${basePath}/report/merchant`,
        merchantTransactionReport: `${basePath}/report/merchant/transaction/list`,
        userTransactionSummary: `${basePath}/transaction/summary/report`,
        dashBoardUserTransactions: `${basePath}/transaction/dashboard/user/report`,
        walletTransactions: `${basePath}/user/wallet/ledger/report`,
        listTransactionSummaryNew: `${basePath}/transaction/wallet/summary`,
        listTransactionSummaryReport: `${basePath}/report/user/transaction/summary`,
        cancelVentajaUnifiedTransaction: `${basePath}/billpayment/ventaja-unified/cancel`,
        inAppRefundDtone: `${basePath}/dtone/refund`,
        getLogs:  `${basePath}/flex-pay-biz/virtual/account/transaction-log/list`,

    },
    FaqUrls = {
        faq: `${basePath}/backoffice/faq`,
        list: `${basePath}/backoffice/faq/list`,
        create: `${basePath}/backoffice/faq/create`,
        update: `${basePath}/backoffice/faq/`
    },

    NotificationUrls = {
        create: `${basePath}/backoffice/notification/create`,
        notificationList: `${basePath}/backoffice/user/notifications`,
        sendNotification: `${basePath}/backoffice/send-notification`,
        bulkNotification: `${basePath}/backoffice/user/bulk/notification`
    },

    // Users

    
    UserUrls = {
        user: `${basePath}/backoffice/user/report`,
        // profileGet: `${basePath}/backoffice/appuser/profile/get/`,
        userUpdate: `${basePath}/backoffice/appuser/profile/update/`,
        closeAccount: `${basePath}/backoffice/appuser/account/closure`,
        profileImageDownload: `${basePath}/backoffice/appuser/profile/picture/download/`,
        cancelRequest: `${basePath}/backoffice/cancel/closure/account`,
        raiseClosureRequest: `${basePath}/backoffice/close/account/request`,
        userWallet: `${basePath}/user/wallet/list`,
        walletBalance: `${basePath}/user/wallet/balance/report`,
        pointList: `${basePath}/backoffice/reward/points/user/report`,
        redeemPoints: `${basePath}/backoffice/reward/points/redeem/list`,
        rewardPointsLedgerlist: `${basePath}/backoffice/reward/points/details`,
        usersPointList: `${basePath}/backoffice/reward/points/userdetails/list`,
        usersPointDownloadreport: `${basePath}/backoffice/reward/points/userdetails/list`,
        userTierReport: `${basePath}/backoffice/reward/points/usertiersetting/list`,
        expenseLedgerReport: `${basePath}/backoffice/expense/ledger/view/list`,
        userStatusHistory: `${basePath}/backoffice/user-status/list`,
        changeMobileHistory: `${basePath}/backoffice/change/mobile/number/history`,
        dashBoardUsersCount: `${basePath}/backoffice/dashboard/user/report`,
    },
    kycUrls = {
        getProvidersList: `${basePath}/remittance/providers/list`,
        getRemitterCustomersList: `${basePath}/remittance/provider/customers/details`,
        getRemIDForiPay: `${basePath}/user/remittance/ipay/kyc`,
        verifyRemIDForFlexRemit: `${basePath}/user/remittance/flex-remit/validate`,
        getRemitterStatus: `${basePath}/user/remittance/ipay/kyccustomer`,
        validateRemIDForAgrani: `${basePath}/user/wallet/remittance/agrani/validate`,
        saveRemitterDetails: `${basePath}/remittance/provider/customers/create`,
        remitterStatusHistory: `${basePath}/remittance/provider/customers/validation/history/list`,
        kycImages: `${basePath}/user/kyc/`,
        deleteKycDocumentImage: `${basePath}/user/kyc/`,
        kycList: `${basePath}/user/kyc/list`,
        kycHistory: `${basePath}/user/kyc/history/list`,
        downloadkycdocument: `${basePath}/user/kyc/`,
        documentList: `${basePath}/user/kyc/documents/list`,
        uploadImages: `upload`,
        onfidoLog: `${basePath}/user/kyc/request-details/list`,
        getRemIDForjufu: `${basePath}/user/kyc/jufu/create/remitter/`,
        getRemIDForAgrani: `${basePath}/user/wallet/remittance/agrani/remid/`,
        amlWatchList: `${basePath}/user/kyc/aml/watch/list`,
        getWebhooks: `${basePath}/user/kyc/request-details/report`,
        getRemIDForATT: `${basePath}/user/kyc/att/create/remitter/`
    },
    PreapprovedUsersUrls = {
        users: `${basePath}/preapproveduser/`,
        create: `create`,
        list: `list`,
    },
    WalletUnloadUrls = {
        unloadAmount: `${basePath}/user/wallet/unload`
    },
    TopupUrls = {
        topup: `${basePath}/user/wallet/funds/add`,
    },
    bulkTopup = {
        validate: `${basePath}/user/wallet/load/validate`,
        topup: `${basePath}/user/wallet/load/bulk`
    },

    bulkUnload = {
        validate: `${basePath}/user/wallet/unload/validate`,
        unload: `${basePath}/user/wallet/unload/bulk`
    },

    bulkPoints = {
        validate: `${basePath}/backoffice/reward/points/custom/bulk/validate`,
        topup: `${basePath}/backoffice/reward/points/custom/bulk`
    },

    MerchantSettlementUrls = {
        merchantSettlementCalculation: `${basePath}/merchant/settlement/calculate`,
        transactionsForSettlement: `${basePath}/merchant/transaction/list`,
        demandSettlement: `${basePath}/merchant/settlement`,
        settlementDocument: `${basePath}/merchant/settlement/list`,
        downloadSettlements: `${basePath}/transaction/merchant/settlements/transactions`,
        refundTrasaction: `${basePath}/merchant/refund`,
        completePayment: `${basePath}/merchant/settlement/update`,
        repost: `${basePath}/merchant/settlement/repost`,
        repostForCanada: `${basePath}/merchant/settlement/repost/canada`,
        repostForCityBank: `${basePath}/merchant/settlement/status`,
        settlementPending: `${basePath}/merchant/settlement/summary`,
        dailySummary: `${basePath}/merchant/report/dailysummary`,
        merchantSettlementSummary: `${basePath}/merchant/merchant-settlement/summary`,

    },

    ActivityUrls = {
        list: `${basePath}/backoffice/user-audit/report`,
    },

    AgentSettlementUrls = {
        transactionsForSettlement: `${basePath}/backoffice/agent/transaction/list`,
    },

    CountryUrls = {
        country: `${basePath}/country/`,
        list: `list`,
        create: `create`,

    },
    BankUrls = {
        bankList: `${basePath}/bank/list`,
        bankCreate: `${basePath}/bank/create`,
        bankEdit: `${basePath}/bank/`,
        bankDelete: `${basePath}/bank/`,
        branchList: `${basePath}/branch/list`,
        branchCreate: `${basePath}/branch/create`,
        branchEdit: `${basePath}/branch/`,
        branchDelete: `${basePath}/branch/`,
        bankBranchList: `${basePath}/bank/branch/list`,
        createBranches: `${basePath}/bank/branch/create`,
        updateBranches: `${basePath}/bank/branch`,
        deleteBranches: `${basePath}/bank/branch`
    },
    remittanceUrls = {
        transactionDetails: `${basePath}/remittance/transaction/details/`,
        statusUpdate: `${basePath}/remittance/transaction/status/update`,
        getProviderStatus: `${basePath}/remittance/transaction/provider/status/update`,
        refund: `${basePath}/user/wallet/refund-money`,
        getProviderResponse: `${basePath}/remittance/transaction/request/details/`,
        getStatusHistory: `${basePath}/remittance/transaction/history/details/`,
        currency: `${basePath}/currency/`,
        currencyList: `list`,
        currencyCreate: `create`,
        completePayment: `${basePath}/remittance/transaction/complete/payment`,
        cancelOrder: `${basePath}/remittance/transaction/cancel/order`,
        completeTransaction: `${basePath}/transaction/complete-transaction`,
        acceptedCurrencyList: `${basePath}/business-accepted/currency/list`,
        addAcceptedCurrency: `${basePath}/business-accepted/currency/create`,
        updateAcceptedCurrency: `${basePath}/business-accepted/currency`
    },

    remittanceProviderPaymentUrls = {
        remittanceProviderPayment: `${basePath}/remittance/providers/payment/`,
        create: `create`,
        list: `list`
    },


    // Topup Parking
    topupParkingUrls = {
        list: `${basePath}/user/wallet/topup-parking/list`,
        balance: `${basePath}/user/wallet/report/list`,
        topup: `${basePath}/user/wallet/topup-parking/topup`,
        refund: `${basePath}/user/wallet/topup-parking/refund`,
        update: `${basePath}/user/wallet/topup-parking/update`,
        history: `${basePath}/user/wallet/topup-parking/history/list`,
    },

    // Agent Management

    agentManagementUrls = {
        addPrefund: `${basePath}/backoffice/agent/fund/request`,
        updateStatus: `${basePath}/backoffice/agent/prefund/request/confirm`,
        transactionList: `${basePath}/backoffice/agent/transaction/list`,
        returnPrefund: `${basePath}/backoffice/agent/fund/return`,
        agentLedgerHistory: `${basePath}/backoffice/agent/transaction/history`,
    },
    settingsUrls = {
        planList: `${basePath}/backoffice/plan/list`,
        planCreate: `${basePath}/backoffice/plan/create`,
        planEdit: `${basePath}/backoffice/plan`,
        planDelete: `${basePath}/backoffice/plan`,
        promocodeCreate: `${basePath}/remittance/transaction/promocode/create`,
        promocodeList: `${basePath}/remittance/transaction/promocode/list`,
        promocodeUpdate: `${basePath}/remittance/transaction/promocode/`,
        promocodeDelete: `${basePath}/remittance/transaction/promocode/`,
        rewardsPointsSet: `${basePath}/backoffice/reward/points/set`,
        rewardsPointsGet: `${basePath}/backoffice/reward/points/get`,
        addCustomPoints: `${basePath}/backoffice/reward/points/custom`,
        rewardsPointsGetLog: `${basePath}/backoffice/reward/points/getlog`,
    },
    modulesUrls = {
        modulesList: `${basePath}/backoffice/module/list`,
        modulesCreate: `${basePath}/backoffice/module/create`,
        modulesEdit: `${basePath}/backoffice/module/update`,
        modulesDelete: `${basePath}/backoffice/module/delete`,
    },

    CommentsUrls = {
        commentsCreate: `${basePath}/comment/create`,
        commentsList: `${basePath}/comment/list`,
        commentsUpdateOrDelete: `${basePath}/comment/`,
    },

    AttachmentUrls = {
        uploadAttachments: `${basePath}/attachment/create/`,
        downloadAttachments: `${basePath}/attachment/download/`,
        deleteAttachments: `${basePath}/attachment/`,
        listAttachments: `${basePath}/attachment/list`
    },
    UsageReportUrls = {
        list: `${basePath}/backoffice/notification/usage-report`,
    },
    UsageRequestReportUrls = {
        list: `${basePath}/backoffice/request/usage-report`,
    },
    TopUpChannelUrls = {
        list: `${basePath}/transaction/topup-list`,
    },

    // Appcode 
    appcodeUrls = {
        list: `${basePath}/backoffice/appsetting/list`,
        update: `${basePath}/backoffice/appsetting/`,
        imageUpload: `${basePath}/backoffice/appsetting/image/upload`,
        imageUpload2: `${basePath}/backoffice/image/upload`,
        uploadImage: `/image/upload`,
        downloadImage: `${basePath}/backoffice/appsetting/image/download/`,
        deleteImage: `${basePath}/backoffice/appsetting`,
    },

    // System 
    systemUrls = {
        list: `${basePath}/setting/list`,
        update: `${basePath}/setting/`,
        viewLogs: `${basePath}/setting/log-list/`
    },

    // Merchant Category Code
    MerchantCategoryCodeUrls = {
        list: `${basePath}/merchant/categorycode/list`,
        create: `${basePath}/merchant/categorycode/create`,
        update: `${basePath}/merchant/categorycode/`,
        delete: `${basePath}/merchant/categorycode/`,
    },

    // Gift Card
    giftCardUrls = {
        list: `${basePath}/backoffice/gift-card/list`,
        create: `${basePath}/backoffice/gift-card/create`,
        update: `${basePath}/backoffice/gift-card/`,
        delete: `${basePath}/backoffice/gift-card/`,
        imageUpload: `${basePath}/backoffice/gift-card/image/upload`,
        downloadImage: `${basePath}/backoffice/gift-card/image/download/`,
        deleteImage: `${basePath}/backoffice`,
        voucherList: `${basePath}/backoffice/gift-card-voucher/list`,
        voucherLogsList: `${basePath}/backoffice/gift-card-voucher/logs`,
    },

    //AirTime Countries
    AirTimeCountriesUrls = {
        fetch: `${basePath}/backoffice/airtime/countries/fetch`,
        list: `${basePath}/backoffice/airtime/countries`,
        update: `${basePath}/backoffice/airtime`,
        listCountry: `${basePath}/backoffice/airtime/country`,
        listPrice: `${basePath}/backoffice/airtime/operator`,
    },

    // Routing Number
    RoutingNumberUrls = {
        listAll: `${basePath}/bank/branch/list/all`,
        list: `${basePath}/bank/branch/list`,
        create: `${basePath}/bank/branch/create`,
        update: `${basePath}/bank/branch/`,
        delete: `${basePath}/bank/branch/`,
    },

    // IFSC Code
    IFSCCodeUrls = {
        listAll: `${basePath}/bank/branch/list/all`,
        list: `${basePath}/bank/branch/list`,
        create: `${basePath}/bank/branch/create`,
        update: `${basePath}/bank/branch/`,
        delete: `${basePath}/bank/branch/`,
    },
    //Money Exchange rate
    MoneyExchangeUrls = {
        listAll: `${basePath}/money-change-rate/list`,
        create: `${basePath}/money-change-rate/create`,
        update: `${basePath}/money-change-rate/`,
        delete: `${basePath}/money-change-rate/`,
        logs: `${basePath}/money-change-rate/logs`,
        country: `${basePath}/country/list`,
    },

    // Stripe Account
    stripeUrls = {
        createAccount: `${basePath}/merchant/enable/stripe`,
        updateAccount: `${basePath}/merchant/update/stripe/account`,
        createPerson: `${basePath}/merchant/create/stripe/person`,
        updatePerson: `${basePath}/merchant/update/stripe/person`,
        createBankAccount: `${basePath}/merchant/payout/banks/create/stripe`,
        updateBankAccount: `${basePath}/merchant/payout/banks/update/stripe`,
        uploadInStripe: `${basePath}/merchant/image/stripe`,
        documentUploadPerson: `${basePath}/merchant/image/stripe`,
        delete: `${basePath}/bank/branch/`,
    },

    // Providers Account
    providersUrls = {
        providersList: `${basePath}/billpayment/providers`,
        providersUpdate: `${basePath}/billpayment/`,

    },
    // apps Account
    appsUrls = {
        appsList: `${basePath}/billpayment/setting/list`,
        appsUpdate: `${basePath}/billpayment/setting/`,

    },
    //users accounts 
    usersAccounts = {
        list: `${basePath}/user/wallet/report`,
        listAll: `${basePath}/user/wallet/report/list`,
        summaryList: `${basePath}/user/wallet/summary/report`,
    },
    // product Account
    productUrls = {
        productCreate: `${basePath}/billpayment/product/create`,
        productList: `${basePath}/billpayment/products`,
        productUpdate: `${basePath}/billpayment/product/update/`,
        productDelete: `${basePath}/billpayment/product/delete/`,
        syncProductList: `${basePath}/billpayment/product/sync`,
        checkAyopopBalance: `${basePath}/billpayment/ayopop/balance`,
        checkVentajaBalance: `${basePath}/billpayment/ventaja/balance`,
        checkBillAvenueBalance: `${basePath}/billpayment/billavenue/balance`,
        checkVentajaUnifiedBalance: `${basePath}/billpayment/ventaja-unified/balance`,
        syncVentajaUnifiedProductList: `${basePath}/billpayment/ventaja-unified/product/sync`,
        countriesList: `${basePath}/dtone/countries/list`,
        syncCounties: `${basePath}/dtone/sync/countries`,
        operatorList: `${basePath}/dtone/operators/list`,
        syncOperators: `${basePath}/dtone/sync/operators`,
        serviceList: `${basePath}/dtone/services/list`,
        syncService: `${basePath}/dtone/sync/services`,
        dtOneProductList: `${basePath}/dtone/products/list`,
        syncDtoneProduct: `${basePath}/dtone/sync/products`


    },
    // Risk Parameter Urls
    riskParamUrls = {
        listRiskParameter: `${basePath}/customer/risk/parameter/list`,
        createRiskParameter: `${basePath}/customer/risk/parameter/create`,
        editRiskParameter: `${basePath}/customer/risk/parameter/`,
        deleteRiskParameter: `${basePath}/customer/risk/parameter/`,
        listDefaultParameter: `${basePath}/default/parameter/list2`,
        createClientRiskParameter: `${basePath}/client/customer/risk/parameter/create`,
        editClientRiskParameter: `${basePath}/client/customer/risk/parameter/`,
        deleteClientRiskParameter: `${basePath}/client/customer/risk/parameter/`,
        listClientRiskParameter: `${basePath}/client/customer/risk/parameter/list`,
        logClientRiskParameter: `${basePath}/client/customer/risk/parameter/log`,
        checkDefaultWeightage: `${basePath}/client/customer/risk/parameter/weightage`
    },
    //merchant document
    DocumentUrls = {
        list: `${basePath}/merchant/contacts/kyc/document/list/`,
    },

    // merchant product urls
    merchantProductUrls = {
        productCreate: `${basePath}/backoffice/merchant/product/create`,
        productList: `${basePath}/backoffice/merchant/product/list`,
        productUpdate: `${basePath}/backoffice/merchant/product/`,
        productDelete: `${basePath}/backoffice/merchant/product/`,
        deleteImage: `${basePath}/backoffice/image/delete/`,
        upload: `${basePath}/backoffice/image/upload`,
        listImages: `${basePath}/backoffice/merchant/product/images/list`,
        downloadImage: `${basePath}//backoffice/image/download/`,
        categoryList: `${basePath}/backoffice/merchant/product/category/list`,
        linkMerchantProductToCategory: `${basePath}/backoffice/merchant/product/category/create`,
        updatelinkMerchantProductToCategory: `${basePath}/backoffice/merchant/product/category/update`,
        deletelinkMerchantProductToCategory: `${basePath}/backoffice/merchant/product/category/`,
        thumbnailUpload: `${basePath}/backoffice/image/upload/`,
        thumbnailDownload: `${basePath}/backoffice/image/download/`,
        thumbnailDelete: `${basePath}/backoffice/image/delete/`,



    },

    // Wallet to bank url
    WalletUrls = {
        wallettobankList: `${basePath}/bank/leger/report`,
        checkBalance: `${basePath}/backoffice/philippines/payout/balance`,
        checkTransactionStatus: `${basePath}/backoffice/philippines/payout/transaction/status`,
        cancelTransaction: `${basePath}/backoffice/philippines/payout/transaction/cancel`


    },
    // merchant product category url
    MerchantProductCategoryUrls = {
        list: `${basePath}/backoffice/merchant/product/category/list`,
        create: `${basePath}/backoffice/merchant/product/category/list/create`,
        update: `${basePath}/backoffice/merchant/product/category/list/`,
        delete: `${basePath}/backoffice/merchant/product/category/list/`,
    },
    logsGetStatusUrls = {
        getStatus: `${basePath}/merchant/bank/verification/status`
    },
    UserDeviceSignatureUrls = {
        list: `${basePath}/backoffice/device-signature/list`,
        statusUpdate: `${basePath}/backoffice/device-signature/`
    },
    deviceSignatureLogUrls = {
        listLogs: `${basePath}/backoffice/device-signatureLog/list`
    },
    // merchant product urls
    membershipProviderUrls = {
        membershipCreate: `${basePath}/membership-provider/create`,
        membershipList: `${basePath}/membership-provider/providers/list`,
        bankVerify: `${basePath}/membership-provider/bank/verify`,
        membershipUpdate: `${basePath}/membership-provider/update/`,
        membershipDelete: `${basePath}/membership-provider/`,
        deleteImage: `${basePath}/backoffice/image/delete/`,
        upload: `${basePath}/backoffice/image/upload`,
        listImages: `${basePath}/backoffice/merchant/product/images/list`,
        downloadImage: `${basePath}//backoffice/image/download/`
    },
    // merchant products offers
    merchantProductOffers = {
        locationproductlist: `${basePath}/backoffice/merchant/location/product/offer/list`,
    },
    MembershipProvidersMerchantsUrls = {
        MembershipMerchantsList: `${basePath}/membership-provider/merchant/list`,
        UpdateMerchant: `${basePath}/membership-provider/merchant/`,
        deleteProviderMerchant: `${basePath}/membership-provider/merchant/`,
        NonMembershipMerchantsList: `${basePath}/membership-provider/merchant/inactive-merchants-list`,
        LinkNonMerchants: `${basePath}/membership-provider/merchant/sync-provider/`
    },
    MembershipProvidersUsersUrls = {
        userList: `${basePath}/membership-provider/user/list`,
        createUser: `${basePath}/membership-provider/user/create`,
        updateUser: `${basePath}/membership-provider/user/`,
        deleteUser: `${basePath}/membership-provider/user/delete/`,
        disableUser: `${basePath}/membership-provider/user/status/`,
        NonMembershipMerchantsList: `${basePath}/membership-provider/merchant/inactive-merchants-list`,
        LinkNonMerchants: `${basePath}/membership-provider/merchant/sync-provider/`
    },
    MembershipProvidersMerchantRequestUrls = {
        listRequest: `${basePath}/membership-provider/requested-merchants/list`,
        createRequest: `${basePath}/membership-provider/merchant-request/create`,
        updateStatusRequest: `${basePath}/membership-provider/merchant-request/status/`,
        deleteRequest: `${basePath}/membership-provider/merchant-request/status/`
    },
    MembershipUsersUrls = {
        list: `${basePath}/membership-provider/membership-users/list`,
        edit: `${basePath}/membership-provider/membership-users/status/`,
    },
    MembershipTransactionsUrls = {
        transactionReport: `${basePath}/membership-provider/transaction-report`,
        repost: `${basePath}/membership-provider/transaction/repost`,
        responseTransaction: `${basePath}/user/kyc/request-details/list`,


    },
    MembershipSettlementUrls = {
        settlement: `${basePath}/membership-provider/settlement`,
        calculation: `${basePath}/membership-provider/settlement/calculate`,
        completePayment: `${basePath}/membership-provider/settlement/update`,
        repostProvider: `${basePath}/membership-provider/settlement/repost`

    },
    MembershipSettlementDocumentsUrls = {
        list: `${basePath}/membership-provider/settlement-documents`,
        // calculation: `${basePath}/membership-provider/settlement/calculate`
    },
    // Cron job
    jobsUrls = {
        jobsCreate: `${basePath}/backoffice/job/create`,
        jobsList: `${basePath}/backoffice/job/list`,
        jobsUpdate: `${basePath}/backoffice/job/update/`,
        jobsDelete: `${basePath}/backoffice/job/delete/`,
        jobsStatus: `${basePath}/backoffice/job`,
        jobsLog: `${basePath}/backoffice/job/log/list`,
        jobsDetails: `${basePath}/backoffice/job/status/list/`,
    },

    targetPopulate = {
        MERCHANT_SETTLEMENT: `${basePath}/merchant/settlement/job`,
        MERCHANT_LOCATION_SETTLEMENT: `${basePath}/backoffice/test/job/post2`,
        TRANSACTION_FEE_SETTLEMENT: `${basePath}/backoffice/test/job/post2`,
        BANK_TRANSFER_SETTLEMENT: `${basePath}/merchant/bank-transfer/settlement/job`,
        LOCATION_SETTLEMENT: `${basePath}/merchant/location/settlement/job`,
        MEMBERSHIP_PROVIDER_SETTLEMENT: `${basePath}/membership-provider/settlement/job`,
        MERCHANT_MONTHLY_TRANSFER_FEE: `${basePath}/merchant/monthly-transfer-fee/job`,
    },
    // banners
    bannersUrls = {
        bannersCreate: `${basePath}/backoffice/banners/group/create`,
        bannersList: `${basePath}/backoffice/banners/group/list`,
        bannersUpdate: `${basePath}/backoffice/banners/group/`,
        bannersDelete: `${basePath}/backoffice/banners/group/`,
        bannerImagesCreate: `${basePath}/backoffice/banners/image/create`,
        bannerImagesList: `${basePath}/backoffice/banners/image/list`,
        bannerImagesUpdate: `${basePath}/backoffice/banners/image/`,
        bannerImagesDelete: `${basePath}/backoffice/banners/image/`,
        downloadImage: `${basePath}/backoffice/banners/image/download/`
    },
    // User guide
    UserGuideUrls = {
        list: `${basePath}/user/guide/list`,
        create: `${basePath}/user/guide/create`,
        edit: `${basePath}/user/guide/`,
        delete: `${basePath}/user/guide/`

    },
    CorrespondentUrls = {
        list: `${basePath}/corresponent/list`,
        create: `${basePath}/corresponent/create`,
        edit: `${basePath}/corresponent/`,
        delete: `${basePath}/corresponent/`,
        statement: `${basePath}/merchant/citi-connect/statementId`,
        getStatementData: `${basePath}/merchant/citi-connect/statement`
    },
    CorrespondentAppUrls = {
        list: `${basePath}/corresponent/app/list`,
        create: `${basePath}/corresponent/app/create`,
        edit: `${basePath}/corresponent/app/`,
        delete: `${basePath}/corresponent/app/`
    },
    CorrespondentBankUrls = {
        list: `${basePath}/corresponent/bank/list`,
        create: `${basePath}/corresponent/bank/create`,
        edit: `${basePath}/corresponent/bank/`,
        delete: `${basePath}/corresponent/bank/`
    },
    CardTypeUrls = {
        list: `${basePath}/card/type/list`,
        create: `${basePath}/card/type/create`,
        edit: `${basePath}/card/type/`,
        delete: `${basePath}/card/type/`,
        uploadAttachment: `${basePath}/attachment/create`,
        listAttachment: `${basePath}/attachment/list`,
        deleteAttachment: `${basePath}/attachment/`,
        downloadAttachment: `${basePath}/attachment/download/`,
    },
    BinCardUrls = {
        list: `${basePath}/bin/card/list`,
        create: `${basePath}/bin/card/create`,
        edit: `${basePath}/bin/card/`,
        delete: `${basePath}/bin/card/`
    },
    AccountCardUrls = {
        list: `${basePath}/account/card/list`,
        logs: `${basePath}/account/card/history`,
    },
    AppResponseMessagesUrls = {
        list: `${basePath}/backoffice/app-response-messages/list`,
        create: `${basePath}/backoffice/app-response-messages/create`,
        edit: `${basePath}/backoffice/app-response-messages/`,
        delete: `${basePath}/backoffice/app-response-messages/`
    },
    CustomerNotificationUrls = {
        list: `${basePath}/backoffice/customer-notification-templates/list`,
        create: `${basePath}/backoffice/customer-notification-templates/create`,
        edit: `${basePath}/backoffice/customer-notification-templates/`,
        delete: `${basePath}/backoffice/customer-notification-templates/`
    },
    LanguageUrls = {
        list: `${basePath}/language/list`,
        create: `${basePath}/language/create`,
        edit: `${basePath}/language/`,
        delete: `${basePath}/language/`
    },
    AppAccessUrls = {
        list: `${basePath}/app-access/list`,
        create: `${basePath}/app-access/create`,
        edit: `${basePath}/app-access/`,
        delete: `${basePath}/app-access/`,
        keyList: `${basePath}/app-access/key/list`,
        keyCreate: `${basePath}/app-access/key/create`,
        keyUpdate: `${basePath}/app-access/key/`,
        keyDelete: `${basePath}/app-access/key/`,

    },
    AppIpaddressUrls = {
        list: `${basePath}/integration-app/ip-address/list`,
        create: `${basePath}/integration-app/ip-address/create`,
        edit: `${basePath}/integration-app/ip-address/`,
        delete: `${basePath}/integration-app/ip-address/`,
    },
    // vouchers
    vouchersUrls = {
        vouchersCreate: `${basePath}/voucher/create`,
        vouchersList: `${basePath}/voucher/list`,
        vouchersUpdate: `${basePath}/voucher/`,
        vouchersDelete: `${basePath}/voucher/`,
        voucherUnlinkedMerchant: `${basePath}/voucher/merchant/unLink`,
        voucherMerchantCreate: `${basePath}/voucher/merchant/create`,
        voucherMerchantList: `${basePath}/voucher/merchant/list`,
        voucherLinkedMerchantDetails: `${basePath}/voucher/merchant/detail`,
        voucherMerchantUpdate: `${basePath}/voucher/merchant/`,
        voucherMerchantDelete: `${basePath}/voucher/merchant/`,
        voucherAttachmentCreate: `${basePath}/attachment/create`,
        voucherAttachmentList: `${basePath}/attachment/list`,
        voucherAttachmentDownload: `${basePath}/attachment/download/`,
        voucherAttachmentDelete: `${basePath}/attachment/`,
        singleVoucherGenerate: `${basePath}/voucher/code/generate`,
        bulkVoucherGenerate: `${basePath}/voucher/code/generate/bulk`,
        bulkVoucherValidate: `${basePath}/voucher/code/generate/validate`,
        voucherCodeList: `${basePath}/voucher/code/list`,
        voucherCodeIssue: `${basePath}/voucher/code/issue`,
        voucherCodeUpdate: `${basePath}/voucher/code/`,
        voucherStatus: `${basePath}/voucher/code/status-log-report`,
        voucherIssuedUsers: `${basePath}/voucher/user/detail`,
        voucherIssue: `${basePath}/voucher/issue`,
        blobUrl: `${basePath}/users/attachments`
    },
    PlatformClientUrls = {
        list: `${basePath}/platform/client/list`,
        create: `${basePath}/platform/client/create`,
        edit: `${basePath}/platform/client/`,
        delete: `${basePath}/platform/client/`,
    },
    PlatformClientAccessUrls = {
        list: `${basePath}/platform/client/access/list`,
        create: `${basePath}/platform/client/access/create`,
        edit: `${basePath}/platform/client/access/`,
        delete: `${basePath}/platform/client/access/`,
    },
    PlatformClientIpaddressUrls = {
        list: `${basePath}/platform/client/ipaddress/list`,
        create: `${basePath}/platform/client/ipaddress/create`,
        edit: `${basePath}/platform/client/ipaddress/`,
        delete: `${basePath}/platform/client/ipaddress/`,
    },
    DefaultParameterUrls = {
        list: `${basePath}/default/parameter/list`,
        create: `${basePath}/default/parameter/create`,
        edit: `${basePath}/default/parameter/`,
        delete: `${basePath}/default/parameter/`,
    },
    MerchantTransactionUrls = {
        transactionList: `${basePath}/merchant/transaction/report/list`,
        summaryList: `${basePath}/merchant/transaction/summary/report`,
        providerSummary: `${basePath}/membership-provider/merchant-transaction-summary`,
    },
    CustomersUrls = {
        List: `${basePath}/customer/list`,
        create: `${basePath}/customer/create`,
        update: `${basePath}/customer/`,
        delete: `${basePath}/customer/`,
        addBulkCustomers: `${basePath}/customer/bulk/upload`,
        uploadAttachments: `${basePath}/attachment/create/`,
        downloadAttachments: `${basePath}/attachment/download/`,
        deleteAttachments: `${basePath}/attachment/`,
        listAttachments: `${basePath}/attachment/list`,
        kycList: `${basePath}/user/kyc/customer/list`,
        kycHistoryList: `${basePath}/user/kyc/customer/history/list`,
    },
    DeviceSignatureReport = {
        report: `${basePath}/backoffice/device-signature/report`
    },
    bulkVoucherUpdate = {
        bulkVoucherPurchase: `${basePath}/voucher/code/bulk/purchase/confirm`,
        bulkVoucherValidate: `${basePath}/voucher/code/bulk/purchase/validate`,
        bulkUserValidate: `${basePath}/voucher/code/bulk/purchase/users/validate`,
        bulkValidConfirm: `${basePath}/voucher/code/bulk/purchase/users/confirm`,
    },
    AppInfoUrls = {
        list: `${basePath}/appinfo/list`,
        create: `${basePath}/appinfo/create`,
        edit: `${basePath}/appinfo/`,
        delete: `${basePath}/appinfo/`,
    },
    MerchantOnboardingUrls = {
        signup: `${basePath}/user/merchant/sign-up`,
        verifyOTP: `${basePath}/user/merchant/verify-otp`,
        verifyOtpStatus: `${basePath}/user/merchant/verify/status`,
        resendOtp: `${basePath}/user/merchant/resend-otp`,
        login: `${basePath}/user/merchant/login`,
        refreshToken: `${basePath}/user/merchant/refresh-token`,
        refreshCustomToken: `${basePath}/user/merchant/refresh-custom-token`,
        updateMerchant: `${basePath}/merchant/`,
        merchantContactCreate: `${basePath}/merchant/contacts/add`,
        merchantContactUpdate: `${basePath}/merchant/contacts/`,
        merchantContactDelete: `${basePath}/merchant/contacts/`,
        merchantCompanyCreate: `${basePath}/merchant/company/add`,
        merchantCompanyUpdate: `${basePath}/merchant/company/`,
        merchantCompanyDelete: `${basePath}/merchant/company/`,
        shareholderDetails: `${basePath}/merchant/owner/report`,
        merchantOnlineStoreCreate: `${basePath}/merchant/online/store/create`,
        onlineStoreDetails: `${basePath}/merchant/online/store/list`,
        merchantOnlineStoreDelete: `${basePath}/merchant/online/store/`,
        updateMerchantOnlineStore: `${basePath}/merchant/online/store/`,
        sentKycLink: `${basePath}/merchant/kyc/send/link`,
        getMerchantData: `${basePath}/merchant/list `,
        countryList: `${basePath}/country/list`,
        settings: `${basePath}/setting/list`,
        createOutletDetails: `${basePath}/backoffice/location/create`,
        getOutletDetails: `${basePath}/backoffice/location/list`,
        editOutletDetails: `${basePath}/backoffice/location/`,
        deleteOutletDetails: `${basePath}/backoffice/location/`,
        list: `${basePath}/merchant/business-model/list`,
        merchantFinanceBillingCreate: `${basePath}/merchant/finance-billing/create`,
        merchantFinanceBilling: `${basePath}/merchant/finance-billing/list`,
        merchantFinanceBillingUpdate: `${basePath}/merchant/finance-billing/`,
        merchantFinanceBillingDelete: `${basePath}/merchant/finance-billing/`,
        listDataAvailability: `${basePath}/merchant/data-availability/list`,
        updateDataAvailability: `${basePath}/merchant/data-availability/`,
        submitStatus: `${basePath}/merchant/verification/update`,
        updateOnboardStatus: `${basePath}/merchant/onboard/approve`,
        historyOnboardStatus: `${basePath}/merchant/verification/log/report`,
        listConversation: `${basePath}/merchant/message/list`,
        createConversation: `${basePath}/merchant/message/create`,
        sentSignLink: `${basePath}/merchant-doc-signature/request`,
        createMerchant: `${basePath}/merchant/onboard/create`,
        bankData: `${basePath}/bank/list`,
        codeList: `${basePath}/merchant/categorycode/list`,
        notifications: `${basePath}/merchant/log/report`,
        approveNotification: `${basePath}/merchant/log/approve/`,
        reminderMail: `${basePath}/merchant/reminder/mail/update`,
        merchantList: `${basePath}/merchant/search/list`
    },
    MerchantBusinessModelUrls = {
        list: `${basePath}/merchant/business-model/list`,
        create: `${basePath}/merchant/business-model/create`,
        update: `${basePath}/merchant/business-model/`,
        delete: `${basePath}/merchant/business-model/`,
    },

    MerchantBusinessModelFeeUrls = {
        list: `${basePath}/merchant/business-model-fee/list`,
        create: `${basePath}/merchant/business-model-fee/create`,
        update: `${basePath}/merchant/business-model-fee/`,
        delete: `${basePath}/merchant/business-model-fee/`,
    },
    MerchantTermsUrls = {
        list: `${basePath}/merchant/business-terms/list`,
        create: `${basePath}/merchant/business-terms/create`,
        update: `${basePath}/merchant/business-terms/`,
        delete: `${basePath}/merchant/business-terms/`,
    },
    CustomerAccountTopupUrls = {
        list: `${basePath}/customer/account/topup-channel/list`,
        create: `${basePath}/customer/account/topup-channel/create`,
        update: `${basePath}/customer/account/topup-channel/`,
        delete: `${basePath}/customer/account/topup-channel/`,
    },
    CustomerAccountSettingsUrls = {
        list: `${basePath}/customer/account-setting/list`,
        create: `${basePath}/customer/account-setting/create`,
        update: `${basePath}/customer/account-setting/`,
        delete: `${basePath}/customer/account-setting/`,
    },
    CustomerTransactionUrls = {
        list: `${basePath}/customer/transaction/list`,
    },
    CustomerAllowedCountriesUrls = {
        list: `${basePath}/client/countries/list`,
        create: `${basePath}/client/countries/create`,
        update: `${basePath}/client/countries/`,
        delete: `${basePath}/client/countries/`,
    },
    remittanceCountryUrls = {
        countryCreate: `${basePath}/remittance/provider/countries/create`,
        countryList: `${basePath}/remittance/provider/countries/list`,
        countryEdit: `${basePath}/remittance/provider/countries/`,
        countryDelete: `${basePath}/remittance/provider/countries/`,
        providerList: `${basePath}/remittance/provider/merchant/list`,
        masterCountryList: `${basePath}/country/list`,
        getAllProviderList: `${basePath}/remittance/providers/list`,
    },
    getCountryUrls = {
        countries: `${basePath}/user/remittance/ipay/countries`,
        flexremitCountries: `${basePath}/user/remittance/flex-remit/countries`,
        deliveryMethods: `${basePath}/user/remittance/ipay/countriesDM`,
        banks: `${basePath}/user/remittance/ipay/banks`
    },
    DeliveryMethodsUrls = {
        merchantlist: `${basePath}/remittance/provider/merchant/list`,
        list: `${basePath}/remittance/payment/mode/list`,
        create: `${basePath}/remittance/payment/mode/create`,
        edit: `${basePath}/remittance/payment/mode/`,
        getDeliverymethods: `${basePath}/user/remittance/flex-remit/delivery-method`
    },
    ProviderSMSRateURls = {
        list: `${basePath}/backoffice/sms-rate/list`,
        create: `${basePath}/backoffice/sms-rate/create`,
        delete: `${basePath}/backoffice/sms-rate/delete/`,
        update: `${basePath}/backoffice/sms-rate/update/`
    },
    regulatoryReportUrls = {
        form1B1footer: `${basePath}/report/semi-annual/transaction/summary`,
        form1B2footer: `${basePath}/report/user/summary`,
    },
    virtualAccountURls = {
        businessList: `${basePath}/flex-pay-biz/virtual/account/list`,
        businessCreate: `${basePath}/flex-pay-biz/virtual/account/create`,
        businessDelete: `${basePath}/flex-pay-biz/virtual/account/`,
        businessUpdate: `${basePath}/flex-pay-biz/virtual/account/`,
        merchantContactCreate: `${basePath}/business/contacts/add`,
        merchantContactUpdate: `${basePath}/business/contacts/`,
        merchantContactDelete: `${basePath}/business/contacts/`,
        merchantCompanyCreate: `${basePath}/business/company/add`,
        merchantCompanyUpdate: `${basePath}/business/company/`,
        merchantCompanyDelete: `${basePath}/business/company/`,
        shareholderDetails: `${basePath}/business/owner/report`,
        countryList: `${basePath}/country/list`,
        settings: `${basePath}/setting/list`,
        sentSignLink: `${basePath}/business-doc-signature/request`,
        codeList: `${basePath}/business/categorycode/list`,
        settingUpdate: `${basePath}/business/config/update`,
        settingList: `${basePath}/business/config/list`,
        businesslistDataAvailability: `${basePath}/business/data-availability/list`,
        businessupdateDataAvailability: `${basePath}/business/data-availability`,
        submitStatus: `${basePath}/business/verification/update`,
        updateOnboardStatus: `${basePath}/business/approve`,
        historyOnboardStatus: `${basePath}/business/verification/log/report`,
        CurrenciesList: `${remitUrl}/inward/sender-currency`,
        merchantAcceptedCurrencyList: `${basePath}/merchant-accepted/currency/list`,
        update: `${basePath}/merchant-accepted/currency`,
        masterData: `${remitUrl}/inward/master-data`
    },
    virtualAccountUserURls = {
        user: `${basePath}/backoffice/`,
        userList: `user/report`,
        createUser: `create-user`,
        editUser: `user/update`,
        deleteUser: `user/delete`,
    },
    virtualAccountsDetails = {
        accountsList: `${basePath}/business/account/list`,
        createAccounts: `${basePath}/business/account/create/primary-account`,
        editUser: `user/update`,
        deleteUser: `user/delete`,
        configDetails: `${basePath}/business/config/list`,
        configCreate: `${basePath}/business/config/create`,
        configUpdate: `${basePath}/business/config/update`,
        paymentTransactionList: `${basePath}/business/transaction/list`,
        completePayment: `${basePath}/business/account/add-money/paynow`,
        currenciesBalance: `${basePath}/business/currency-wise/balance`,
        sendRefund: `${basePath}/business/transaction/send-refund`,
    },
    virtualAccountsFinanceAndBilling = {
        virtualAccountsFinanceBillingCreate: `${basePath}/business/finance-billing/create`,
        virtualAccountsFinanceBilling: `${basePath}/business/finance-billing/list`,
        virtualAccountsFinanceBillingUpdate: `${basePath}/business/finance-billing/`,
        virtualAccountsFinanceBillingDelete: `${basePath}/business/finance-billing/`,
    },
    ReferralDetails = {
        createNewReferralAccount: `${basePath}/business/referral-master/create`,
        getList: `${basePath}/business/referral-master/list`,
        editReferralAccount: `${basePath}/business/referral-master/`,
        createUser: `${basePath}/backoffice/create-user`,
        getUserList: `${basePath}/backoffice/user/report`,
        updateUser: `${basePath}/backoffice/user/update`
    },
    MerchantDetails = {
        getList: `${basePath}/business/merchant-referral-mapping/list`,
    },
    PayByPayOutUrls = {
        list: `${basePath}/business/payment-method/list`,
        create: `${basePath}/business/payment-method/create`,
        edit: `${basePath}/business/payment-method/`,
    },
    TMUrls = {
        complianceQueueList: `${basePath}/business/transaction/approval-report`,
        approveTransaction: `${basePath}/business/approve/transaction-monitor`
    },
    exchangeRateUrls = {
        list: `${basePath}/market-exchange-rate/list`,
        create: `${basePath}/market-exchange-rate/create`,
        update: `${basePath}/market-exchange-rate`
    },
    masterAccountUrls = {
        masterAccountList: `${basePath}/business/master-account/list`,

    },
    DirectRemittance = {
        approve: `${basePath}/business/approve-money-direct-remittance`
    },

    RemitUrls = {
        countryList: `${remitUrl}/inward/countries-new`,
        getCurrency: `${remitUrl}/inward/country-currency`,
    },

    CorridorUrls = {
       create : `${basePath}/business/crossborder-fee/create`,
       list : `${basePath}/business/crossborder-fee/list`,
       update : `${basePath}/business/crossborder-fee/update`,
       delete : `${basePath}/business/crossborder-fee/delete`,
    },

    SupportEmail = {
         create : `${basePath}/business/support-email/create`,
       list : `${basePath}/business/support-email/list`,
       base: `${basePath}/business/support-email`
    },

    IpWhitelistingUrls = {
        create : `${basePath}/business/ip-address-whitelist/create`,
        list   : `${basePath}/business/ip-address-whitelist/list`,
        base   : `${basePath}/business/ip-address-whitelist`,
    }


export const nonEncryptResponseUrlList = [
    '/attachment/create/', 'merchant/image/download/', 'merchant/image/upload', '/download/'];
